import { Portal } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import React from "react";

interface CustomSnackbarProps {
  open: boolean;
  handleClose: () => void;
  severity: "success" | "error" | "info";
  message: string;
}

function CustomSnackbar({ open, handleClose, severity, message }: CustomSnackbarProps) {
  return (
    <Portal>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ zIndex: Number.MAX_SAFE_INTEGER }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <MuiAlert elevation={6} onClose={handleClose} variant="filled" severity={severity}>
          {message}
        </MuiAlert>
      </Snackbar>
    </Portal>
  );
}

export default CustomSnackbar;
